var _a;
class HtmlBuilder {
    static updateLabel(block, label) {
        const $label = block.querySelector(`.${this.labelClass}`);
        if ($label)
            $label.innerHTML = label;
        return label;
    }
    static createBlock(label, ...inputOrSelectNode) {
        const $block = document.createElement('div');
        const $label = document.createElement('div');
        const $input = document.createElement('div');
        $block.classList.add(this.blockClass);
        $label.classList.add(this.labelClass);
        $label.innerHTML = label;
        $input.classList.add(`${this.blockClass}-label`);
        $input.append(...inputOrSelectNode);
        $block.append($label, $input);
        return $block;
    }
    static createRow() {
        const $row = document.createElement('div');
        $row.classList.add(`${this.rootClass}__row`);
        return $row;
    }
    static createCartCell(val) {
        const $cell = document.createElement('td');
        $cell.classList.add(`${this.cartClass}__item`);
        $cell.textContent = val;
        return $cell;
    }
    static createCartCellWithDelete() {
        const $cell = document.createElement('td');
        const $deleteBtn = document.createElement('button');
        $cell.classList.add(`${this.cartClass}__item`);
        $deleteBtn.classList.add(`${this.cartClass}__row__del`);
        $deleteBtn.type = 'button';
        $cell.append($deleteBtn);
        return $cell;
    }
    static createCartCellWithInput(qty) {
        const $cell = document.createElement('td');
        $cell.setAttribute('class', `${this.cartClass}__item`);
        const td = `
    <div
      class="${this.cartClass}__item__qty"
      style="display: inline-flex; align-items: center; column-gap: 3px"
    >
      <input type="button" value="-" style="margin: 0; padding: 6px 12px" data-action="minus">
      <span style="padding: 0 5px">${qty}</span>
      <input type="button" value="+" style="margin: 0; padding: 6px 12px" data-action="plus">
    </div>`;
        $cell.insertAdjacentHTML('afterbegin', td);
        return $cell;
    }
}
_a = HtmlBuilder;
HtmlBuilder.rootClass = 'calcZV';
HtmlBuilder.blockClass = `${_a.rootClass}__block`;
HtmlBuilder.cartClass = `${_a.rootClass}__cart`;
HtmlBuilder.labelClass = `${_a.blockClass}-title`;
export default HtmlBuilder;
